import { getBrand } from '@/components/ui/brands';

/** Display-only match against the existing bank-brand registry; unknown institutions stay neutral. */
export function institutionBrandSlug(name: string): string | null {
  const normalized = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const match = [
    [/(?:\bnubank\b|nu pagamentos)/, 'nubank'],
    [/\b(?:banco\s+)?xp\b/, 'xp'],
    [/\bbradesco\b/, 'bradesco'],
    [/\bitau\b/, 'itau'],
    [/\bsantander\b/, 'santander'],
    [/\b(?:banco\s+do\s+brasil|bb)\b/, 'bb'],
    [/\b(?:caixa economica|caixa)\b/, 'caixa'],
    [/\b(?:banco\s+inter|inter)\b/, 'inter'],
    [/\bc6\b/, 'c6'],
    [/\bbtg\b/, 'btg'],
  ] as const;
  return match.find(([pattern]) => pattern.test(normalized))?.[1] ?? null;
}

export function institutionBrand(name: string) {
  const slug = institutionBrandSlug(name);
  return slug ? getBrand(slug) : undefined;
}
